module.exports = __webpack_public_path__ + "static/img/6.29e0d52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/sanxing/6.png
// module id = 7G5q
// module chunks = 0